import { Navigate } from "react-router-dom";
import useAuthStore from "../../store/auth.store";

// Route guard for /ingest/* — defense-in-depth over the per-page gate.
// Backend already enforces the IsIngestAllowed permission, but a B2C user
// who guesses a deep-link (e.g. /ingest/new) shouldn't see the page chrome
// flash before the in-page gate kicks in.
//
// Redirects unauthorised users to /dashboard with no toast (silent — they
// shouldn't have known the route existed).
export default function RequireIngest({ children }) {
  const { user, isAuthenticated, loading } = useAuthStore();
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  // Superusers always allowed — ingest is now an admin-only surface
  // (F9 consolidation), and the founder may not have the legacy
  // ``is_ingest_allowed`` flag explicitly set on their User row.
  if (!user?.is_ingest_allowed && !user?.is_superuser) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
